export default class SelectPromotionEvent {
    export() {
        return {
            'promotion_id': this.promotionId,
            'promotion_name': this.promotionName
        };
    }
}
